import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMedal = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 21,
	height: 20,
	viewBox: "0 0 21 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("mask", {
		id: "mask0_1702_8452",
		style: { maskType: "alpha" },
		maskUnits: "userSpaceOnUse",
		x: 0,
		y: 0,
		width: 21,
		height: 20,
		children: /* @__PURE__ */ _jsx("rect", {
			x: .5,
			width: 20,
			height: 20,
			fill: "#D9D9D9"
		})
	}), /* @__PURE__ */ _jsx("g", {
		mask: "url(#mask0_1702_8452)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M9.60482 10.6243L10.5007 9.93685L11.3757 10.6243C11.5284 10.7493 11.6951 10.7528 11.8757 10.6348C12.0562 10.5167 12.1118 10.3605 12.0423 10.166L11.6882 9.04102L12.6882 8.24935C12.8409 8.12435 12.8861 7.9681 12.8236 7.7806C12.7611 7.5931 12.6326 7.49935 12.4382 7.49935H11.2507L10.8965 6.39518C10.827 6.20074 10.6951 6.10352 10.5007 6.10352C10.3062 6.10352 10.1743 6.20074 10.1048 6.39518L9.75065 7.49935H8.56315C8.36871 7.49935 8.23676 7.59657 8.16732 7.79102C8.09787 7.98546 8.13954 8.13824 8.29232 8.24935L9.29232 9.04102L8.93815 10.166C8.86871 10.3605 8.92079 10.5167 9.0944 10.6348C9.26801 10.7528 9.43815 10.7493 9.60482 10.6243ZM6.60482 18.791C6.32704 18.8882 6.07357 18.8535 5.8444 18.6869C5.61523 18.5202 5.50065 18.298 5.50065 18.0202V12.7285C4.97287 12.1452 4.56315 11.4785 4.27148 10.7285C3.97982 9.97852 3.83398 9.1799 3.83398 8.33268C3.83398 6.47157 4.47982 4.89518 5.77148 3.60352C7.06315 2.31185 8.63954 1.66602 10.5007 1.66602C12.3618 1.66602 13.9382 2.31185 15.2298 3.60352C16.5215 4.89518 17.1673 6.47157 17.1673 8.33268C17.1673 9.1799 17.0215 9.97852 16.7298 10.7285C16.4382 11.4785 16.0284 12.1452 15.5007 12.7285V18.0202C15.5007 18.298 15.3861 18.5202 15.1569 18.6869C14.9277 18.8535 14.6743 18.8882 14.3965 18.791L10.5007 17.4993L6.60482 18.791ZM10.5007 13.3327C11.8895 13.3327 13.0701 12.8466 14.0423 11.8743C15.0145 10.9021 15.5007 9.72157 15.5007 8.33268C15.5007 6.94379 15.0145 5.76324 14.0423 4.79102C13.0701 3.81879 11.8895 3.33268 10.5007 3.33268C9.11176 3.33268 7.93121 3.81879 6.95898 4.79102C5.98676 5.76324 5.50065 6.94379 5.50065 8.33268C5.50065 9.72157 5.98676 10.9021 6.95898 11.8743C7.93121 12.8466 9.11176 13.3327 10.5007 13.3327ZM7.16732 16.6868L10.5007 15.8327L13.834 16.6868V14.1035C13.3479 14.3813 12.8236 14.6 12.2611 14.7598C11.6986 14.9195 11.1118 14.9993 10.5007 14.9993C9.88954 14.9993 9.30273 14.9195 8.74023 14.7598C8.17773 14.6 7.65343 14.3813 7.16732 14.1035V16.6868Z",
			fill: "#1C1B1F"
		})
	})]
});
export default SvgMedal;
